import { MainNavLink } from '@salecycle/ui-component-library';
import { useFlags, usePermissions } from 'core/app/AppContext';
import { Permission } from 'entities/user';
import React from 'react';
import { NavLink } from 'react-router-dom';

interface IProps {
  permissions: Permission[];
  /**
   * @deprecated Prefer useFeatureFlag hook instead.
   * For more info: https://github.com/SaleCycle/my-salecycle-com/wiki/Feature-Flags
   */
  featureFlags?: string[];
  to: string;
  icon: string;
  tooltipDescription: string;
  exact?: boolean;
  atLeastOnePermission?: boolean;
  testId?: string;
}

export const AuthorisedMainNavLink: React.FC<IProps> = (props: IProps) => {
  const { hasPermissionsAll, hasPermissionsAtLeastOne } = usePermissions();
  const { hasFlags } = useFlags();
  const hasPermissions = props.atLeastOnePermission ? hasPermissionsAtLeastOne : hasPermissionsAll;

  return hasPermissions(props.permissions) && hasFlags(props.featureFlags) ? (
    <NavLink
      aria-label={props.tooltipDescription}
      to={props.to}
      exact={props.exact ?? false}
      data-testid={props.testId}
    >
      <MainNavLink icon={props.icon} tooltipDescription={props.tooltipDescription} />
    </NavLink>
  ) : null;
};
